import React from "react";

import { FlexDiv } from "@/components/Atoms/Box";
import ErrorUI from "@/components/Atoms/ErrorUI";
import Button from "@/components/Atoms/Button";
import Loader from "@/components/Atoms/Loader";
import EmailInputV2 from "@/components/Organisms/FormInputsV2/EmailInput";
import NameInputV2 from "@/components/Organisms/FormInputsV2/NameInput";
import PhoneInputV2 from "@/components/Organisms/FormInputsV2/PhoneInput";

import { classNameGenerator } from "@/utils";

import styles from "./DownloadPDFForm.module.scss";

interface FormInputProps {
  control: any;
  isLoading?: boolean;
  showNameField?: boolean;
  namePlaceholder: string;
  showPhoneField?: boolean;
  phonePlaceholder: string;
  showEmailField?: boolean;
  emailPlaceholder: string;
  handleBlur?: () => void;
  formError: {
    message: string;
    type: string;
  };
}

const FormInput: React.FC<FormInputProps> = ({
  control,
  isLoading,
  showNameField,
  namePlaceholder,
  showPhoneField,
  phonePlaceholder,
  showEmailField,
  emailPlaceholder,
  handleBlur = () => {},
  formError,
}) => {
  const cls = classNameGenerator(styles);

  const nameField = showNameField && (
    <NameInputV2
      className="className"
      name="name"
      control={control}
      namePlaceholder={namePlaceholder}
      isNotAbsolute
      showIcon
      variant="v2"
    />
  );

  const phoneField = showPhoneField && (
    <PhoneInputV2
      name="mobile"
      control={control}
      mobilePlaceholder={phonePlaceholder}
      handleBlur={handleBlur}
      isNotAbsolute
      showIcon
      variant="v2"
    />
  );

  const emailField = showEmailField && (
    <EmailInputV2
      name="email"
      control={control}
      emailPlaceholder={emailPlaceholder}
      handleBlur={handleBlur}
      isNotAbsolute
      showIcon
      variant="v2"
    />
  );

  const primaryCTA = (
    <FlexDiv justifyContent="center">
      <Button isLoading={isLoading} className={cls("button")} type="submit">
        <span>Submit details</span>
        {isLoading && (
          <>
            &nbsp; <Loader />
          </>
        )}
      </Button>
    </FlexDiv>
  );

  return (
    <>
      {nameField}
      {phoneField}
      {emailField}
      {formError?.message && (
        <ErrorUI isNotAbsolute error={formError?.message} />
      )}
      {primaryCTA}
    </>
  );
};

export default FormInput;
